import React, { Fragment, useState } from "react";
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Alert, Row,
} from "reactstrap";
import Navbarh from "../navbar/Navbar";
import "../estilos.css";

import * as IoIcons from "react-icons/io";
import Moment, { updateLocale } from "moment";
import classnames from "classnames";
import Proveedores from "./Proveedores";

const initialfFormState = { formType: "Compras" };

function Compras() {
    //Declaración de variables
    const { formType } = initialfFormState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pcompras = window.$Compras ? window.$Compras : false;
    const [tituloTab, setTituloTab] = useState(
        pcompras ? "Generar invoice" : "Detalle de invoice"
    );
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);

    const onDismiss = () => setAVisible(false);
    const [activeTab, setActiveTab] = useState("1");

    Moment.locale("en");
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);
    now.setDate(now.getDate() + 5);


    const toggle1 = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    };




    return (
        <>
            <Navbarh />
            {pcompras === true && (
                <>
                    <Row>
                        <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <IoIcons.IoMdCart
                                className="iconoc floatleft"
                                onClick={() => {
                                    toggle1("1");
                                }}
                            />
                            <h3>{formType}</h3>
                        </div>
                    </Row>
                    <div className="conteiner2">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}

                        <Fragment>
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === "1" })}
                                            onClick={() => {
                                                toggle1("1");
                                            }}
                                        >
                                            Compras
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => {
                                                toggle1("2");
                                            }}
                                        >
                                            Proveedores
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === "3" })}
                                            onClick={() => {
                                                toggle1("3");
                                            }}
                                        >
                                            {tituloTab}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={{ display: "none" }}>
                                        {/*style={{ display: "none" }} */}
                                        <NavLink
                                            className={classnames({ active: activeTab === "4" })}
                                            onClick={() => {
                                                toggle1("4");
                                            }}
                                        >
                                            Imprimir
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">

                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Proveedores />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <h5>Packings</h5>
                                    </TabPane>
                                    <TabPane tabId="4"></TabPane>
                                </TabContent>
                            </div>
                        </Fragment>
                    </div>
                </>
            )}
        </>
    );
}

export default Compras;
